export default __webpack_public_path__ + "static/media/element_83.ffe4f158.avif";